export const headerData = {
  tableName: 'Categories',
  hasSearch: true,
  hasPaging: true,
  isExpandable: true,
  fields: [
    {
      fieldName: 'chatQuestion',
      headerName: 'Questions',
    },
    {
      fieldName: 'categoryText',
      headerName: 'Category',
    },
    {
      fieldName: 'dateCreated',
      headerName: 'Date and Time',
      isDatetime: true,
    },
  ],
};
